import { TYPES } from 'src/common/constants';
import * as client from '../../services/client';

const fetchAllItemTypesDone = payload => ({
    type: TYPES.FETCH_ALL_ITEM_TYPES_DONE,
    payload,
  });
export const fetchAllItemTypes = () => dispatch =>{
    return client.getAllItemTypes().then(
      response=>{
        if(response.ok || response.status === 200){
           return response.json().then(responsejson => {
               let itemTypeOptions = responsejson.map(itemType => ({ value: itemType.id, label: itemType.name }))
               dispatch(fetchAllItemTypesDone(itemTypeOptions))
            })
        } else {
          // alert('Something went wrong with fetching all item types')
        }
      }
    )
  }

const getAllUserTypeRolesDone = payload => ({
    type:TYPES.GET_ALL_USER_TYPE_ROLES,
    payload
})
  export const getAllUserTypeRoles = () => dispatch =>{
    return client.getAllRoles().then(
      response => {
        if(response.ok || response.status === 200){
           return response.json().then( responsejson => {
            dispatch(getAllUserTypeRolesDone(responsejson))
           })
        }else{
          // alert('Something went wrong with fetching roles')
        }
      }
    )
  }

  export const setBuildVersion = (payload) => {
    return {
      type: TYPES.SET_BUILD_VERSION,
      payload
    };
  }
  
